import { Icon } from '@acme/assets';

export const Success = ({
  className,
  title,
  text,
}: {
  className?: string;
  title?: string;
  text?: string;
}) => {
  return (
    <div className={`${className}`}>
      <div
        className={`font-inter flex w-full flex-col items-center gap-2  text-center leading-[normal] ${className}`}
      >
        <Icon name="check" size={44} />
        <div className="self-stretch pt-6 font-medium">{title}</div>
        <div className="text-text-secondary self-stretch">{text}</div>
      </div>
    </div>
  );
};
